import { ensurePdfExtension } from "../utils/documentFileName";

const PDF_TYPE = "application/pdf";

export const validatePdfBlob = (blob: Blob) => {
  if (!blob || blob.size === 0) {
    throw new Error("The generated document is empty.");
  }
  return blob.type === PDF_TYPE ? blob : blob.slice(0, blob.size, PDF_TYPE);
};

export const downloadDocument = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(validatePdfBlob(blob));
  const link = document.createElement("a");
  link.href = url;
  link.download = ensurePdfExtension(fileName);
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
};

export const downloadPdfFromApi = async (
  endpoint: string,
  init?: RequestInit,
): Promise<Blob> => {
  const response = await fetch(endpoint, {
    ...init,
    credentials: init?.credentials ?? "include",
    headers: { Accept: PDF_TYPE, ...init?.headers },
  });

  if (!response.ok) throw new Error("The document request failed.");
  return validatePdfBlob(await response.blob());
};
